import _ from 'lodash';
import Backbone from 'backbone';

import ErrorView from '@/views/ErrorView/ErrorView';
import Scaffold from '@/Scaffold';
import { userHasRole } from '@/util/RoleUtils';

import LogAProblemView from '../views/LogAProblemView'

export default async function loadLogAProblemView() {
  if (!userHasRole('Admin')) {
    showErrorView({ message: 'Unauthorized' });
    return;
  }

  try {
    return new LogAProblemView({
      model: new Backbone.Model({})
    });
  } catch (err) {
    showErrorView(err);
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred'
      })
    })
  );
}